import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { GenerateTokenService, Token } from 'integrationpingid-lib';
import { environment } from 'src/environments/environment';

/**
 * Servicio compartido para operaciones DIS en Ecuador.
 * Centraliza las llamadas HTTP al endpoint DIS para SICOM_SUMMARY y MICROFINANCE.
 */
@Injectable({
  providedIn: 'root'
})
export class EcDisService {

  constructor(
    private http: HttpClient,
    public serviceToken: GenerateTokenService,
    private localStorageService: LocalStorageService
  ) { }

  private getTokenToHeaders() {
    let headerDict: { Authorization: string; };
    if (this.localStorageService.getIsVip) {
      headerDict = { Authorization: "Bearer " + localStorage.getItem('access_token') };
    } else {
      let token: Token = {};
      if (this.serviceToken.statusTokenUser()) {
        token = this.serviceToken.getTokenUser();
      }
      headerDict = { Authorization: token.token_type + " " + token.access_token };
    }
    return headerDict;
  }

  /**
   * Envía el payload al servicio DIS de Ecuador.
   * @param source La ruta del dominio/subdomain (ejemplo: "EC_CREDIT/SICOM_SUMMARY")
   * @param payload Los datos a enviar
   * @param service Nombre del servicio (opcional, para mock)
   * @returns Observable con la respuesta del servicio DIS
   */
  public postDisPayloadEC(source: string, payload: any, service?: any): Observable<any> {
    const urlBaseApi = (this.localStorageService.getIsVip)
      ? environment.VIP_URL_BASE_API
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? "/" + (this.localStorageService.getIsVip
        ? 'vip/dis-service'
        : this.localStorageService.configInit["F_URL_MS_IM_DIS"])
      : "";
    const API_VERSION = this.localStorageService.getIsVip
      ? 'v2'
      : 'api/v2';

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      return this.http.post<any>(
        `${urlBaseApi}${rutaMicroservicio}/${API_VERSION}/DIS/EC/${source}`,
        payload, {
        headers: this.getTokenToHeaders()
      }).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    } else {
      return of({ "type": "mockResponse", "data": payload, service });
    }
  }
}
